<template>
  <div>
    <van-dialog v-model="visible" title="合同项目信息" width="95%" style="height:80%;" class="editClue" :beforeClose="closeProject" :close-on-click-overlay="true" :showConfirmButton = 'false'>
      <van-button style="margin: 10px auto;width: 30%;" class="topBtn" round block type="info" native-type="button" size="small" @click="addProject">+添加项目</van-button>
      <div style="height: 100%; overflow: scroll;">
        <van-list v-if="projectList.length > 0" style="margin-top: -50px">
          <van-cell-group v-for="(item,index) in projectList" :key="index" style="padding-bottom: 10px;">
            <div class="flex-c-center" v-if="item">
              <div style="flex: 1">
                <div style="color: #666;font-size: 14px;padding: 10px 20px;line-height: 22px">
                  <span style="color: #333;">{{`【${item.percentage}%/${item.calculationMethodStr}】${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}}</span>
                </div>
              </div>
            </div>
            <div class="btns">
              <van-button type="info" size="mini" @click="handleProjectPoint(item)">返点</van-button>
              <van-button type="warning" size="mini" @click="handleProjectUpdate(item,index)">修改</van-button>
              <van-button size="mini" color="#ee0a24" v-hasPermi="['cont:project:remove']" @click="handleProjectDelete(item)">删除</van-button>
              <van-button type="primary" size="mini" @click="handleAccountID(item)">账户ID</van-button>
            </div>
          </van-cell-group>
        </van-list>
      </div>
    </van-dialog>

    <!-- 选择项目名称弹窗 -->
    <cont-project-name :contractId="contractId" :projectId="projectForm.projectId" :selectProjectVisible="selectProjectVisible" :isFirst="isFirst" @confirm="setProjectName"></cont-project-name>
    <!-- 项目名称返点弹窗 -->
    <project-point :setPointVisible="setPointVisible" :contractId="contractId" :projectId="projectForm.projectId" :projectName="projectForm.projectName" @savePoint="setProjectPoint"></project-point>
    <!-- 项目绑定账户ID -->
    <account-id ref="accountId"></account-id>
  </div>
</template>

<script>
import newContract from '@/api/cont/newContract'
// import payment from '@/api/cont/payment'
import { Toast, Dialog } from 'vant'
import ContProjectName from '@/views/cont/components/ContProjectName.vue'
import ProjectPoint from '@/views/cont/components/ProjectPoint.vue'
import AccountId from '@/views/channel/recharge/AccountId'
export default {
  components: {
    ContProjectName,
    ProjectPoint,
    AccountId,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  props: {
    setProjectVisible: Boolean,
    contractId: [Number, String]
  },
  watch: {
    setProjectVisible: {
      immediate: true,
      handler(val, oldVal) {
        this.visible = val
        this.getProjectList()
        this.getContractInfo()
      }
    }
  },
  data() {
    return {
      selectProjectVisible: false,
      isFirst: false,
      projectForm: { projectId: null },
      projectList: [],

      setPointVisible: false,

      visible: false,

      contInfo: {}
    }
  },
  mounted() {

  },
  methods: {
    // 获取项目名称列表
    getProjectList() {
      newContract.listProjectPercentage({ bussType: 1, bussId: this.contractId }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
        }
      })
    },
    // 获取合同信息
    getContractInfo() {
      newContract.getContract(this.contractId).then(res => {
        if (res.code == 200) {
          this.contInfo = res.data
        }
      })
    },
    // 新增项目名称
    addProject() {
      this.projectForm = { projectId: null, calculationMethod: 1 }
      if (this.projectList.length == 0) {
        this.isFirst = true
      } else {
        this.isFirst = false
      }
      this.selectProjectVisible = true
    },
    handleProjectPoint(row) {
      this.projectForm = row
      this.setPointVisible = true
    },
    // 修改项目名称
    handleProjectUpdate(row, index) {
      if (index == 0) {
        this.isFirst = true
      } else {
        this.isFirst = false
      }
      this.projectForm = row
      this.selectProjectVisible = true
    },
    setProjectName(projectForm) {
      if (projectForm.projectName) {
        if (this.projectForm.projectId) {
          newContract.updateProject({ ...this.projectForm, ...projectForm }).then(res => {
            if (res.code == 200) {
              Toast.success('项目名称修改成功')
              this.getProjectList()
            } else {
              Toast.fail(res.msg)
            }
          })
        } else {
          newContract.addProject({ bussType: 1, bussId: this.contractId, ...projectForm }).then(res => {
            if (res.code == 200) {
              Toast.success('项目名称添加成功')
              this.getProjectList()
            } else {
              Toast.fail(res.msg)
            }
          })
        }
      }
      this.selectProjectVisible = false
      this.isFirst = false
    },
    // 删除项目名称
    handleProjectDelete(row) {
      const that = this
      Dialog.confirm({
        message: '是否确认删除项目名称为"' + row.projectName + '"的数据项?'
      })
        .then(() => {
          newContract.delProject(row.projectId).then(res => {
            if (res.code == 200) {
              that.getProjectList()
              Toast.success('删除成功')
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleAccountID(row) {
      const params = {
        contractId: this.contInfo.contractId,
        projectId: row.projectId,
        projectName: row.projectName,
        endDateStr: this.contInfo.endTime,
        execCustomerId: null,
        execCustomerName: null,
        dataType: this.contInfo.channelType == 3 ? 2 : 1
      }
      this.$refs.accountId.handleAccountID(params, 'list')
    },
    getAuthIds() {

    },
    setProjectPoint() {
      this.setPointVisible = false
      this.getProjectList()
    },
    closeProject(type, done) {
      done()
      this.$emit('closeProject', '')
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/.van-dialog__content {
  height: 82%;
}
.btns{
  display: flex;
  justify-content: center;
  .van-button {
    width: 20%;
    border-radius: 10px;
  }
}
</style>
